import { Button, Row, Typography } from 'antd';
import { useMemo } from 'react';
import { Show } from '@/components/util/Show';
import type { UploadedFile } from './types';

const { Title } = Typography;

type StepThreeProps = {
    finalizar: () => void;
    uploadedFiles: UploadedFile[];
};

export function StepThree(props: StepThreeProps) {
    const { finalizar, uploadedFiles } = props;

    const processamentoSucedido = useMemo(
        (): boolean => !uploadedFiles.some((file) => file.status !== 'sucesso'),
        [uploadedFiles],
    );

    return (
        <Row
            className='relative flex flex-col items-center'
            style={{
                minHeight: 200,
            }}
        >
            <Title
                className={`w-full text-center ${processamentoSucedido ? undefined : 'text-red-500'}`}
                level={3}
            >
                {processamentoSucedido
                    ? 'Processamento concluído com sucesso!'
                    : 'Processamento concluído com erros'}
            </Title>

            <Show when={!processamentoSucedido}>
                <Title className='mt-1 text-red-500' level={4}>
                    Verifique os motivos abaixo:
                </Title>
            </Show>

            <Button
                onClick={finalizar}
                style={{
                    bottom: 0,
                    position: 'absolute',
                    right: 0,
                    width: 300,
                }}
                type='primary'
            >
                Finalizar
            </Button>
        </Row>
    );
}
